import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import SuccessAlertModal from "../Modals/successAlertModal";
import { useNavigate } from "react-router-dom";
import GolbalSearch from "../utility/common/helpers/GolbalSearch";
import { Button, Row, Col, Container } from "react-bootstrap";
import Export from "../../icons/Export.svg";
import GlobalColumnDefinations, { getHeader_FieldName } from "../utility/grid/definitions/AgGridDefination";
import GridMaster from "../utility/grid/GridMaster";
import Toaster from "../utility/ui/notifications/Toaster";
import { getWpqNpcilLink } from "../../Services/WI-services";
import { RenderIf } from "../../functions/welding-functions";
import MultiValuePopUp from "../utility/ui/modals/MultiValuePopUp";
import { GridLoader } from "react-spinners";
import UnifiedActionRenderer from "../utility/grid/renderers/ActionRenderers/UnifiedActionRenderer";
import { handleExport1 } from "../utility/data/export/GlobalExport";
import { getLinkedWPQRecords, getWPQLinkingData } from "./WPQLinkingCommon";

const WPQ_Linking_Radio = {
  Linked: "Link WPQ with Project",
  UnLinked: "Linking WPQ with project not Required",
};

const WpqNpcilLinking = forwardRef((props, ref) => {
  const npcilflag = props.flag;
  const [welData, setWelData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [, setGroove] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [jointType, setJointType] = useState("");
  const [wiWelderId, setWiWelderId] = useState("");
  const [, setWIJointId] = useState("");
  const childRef = useRef();
  const year = new Date().getFullYear()

  const [showSuccess, setShowSuccess] = useState(false);
  const msg = "";
  const history = useNavigate();

  const [popUp, setPopUp] = useState({
    name: "",
    type: "",
    key: "",
    value: "",
  });

  const showPopUp = (name, type, key, value) => {
    setPopUp({ name, type, key, value });
    setShowForm(true);
  };

  const jointHyperLinkRenderer = (params) => {
    const data = params.data;
    return (
      <Button
        variant="link"
        onClick={() => {
          setJointType(data.WI_Joint_Type);
          setWIJointId(data.WI_Joint_No);
          setWelData(data);
          if (data.WI_Wpq_Radio !== WPQ_Linking_Radio.UnLinked) {
            const welderIds = data.WI_Joint_No.split(",");
            let temp = [];
            for (let ele of welderIds) {
              temp.push({ "WCS_Joint_No": ele })
            }
            showPopUp("NPCILGrid", "Multiple", "WI_Joint_No", temp);
          }
        }}
        size="sm"
      >
        {data.WI_Joint_No}
      </Button>
    );
  };

  const hyperLinkRenderer = (params) => {
    const data = params.data;
    return (
      <Button
        variant="link"
        onClick={async () => {
          setLoading(true);
          setJointType(data.WI_Joint_Type);
          setWelData(data);
          let linkedWpq = await getWPQLinkingData(data);
          let linkedData = await getLinkedWPQRecords(linkedWpq.join(","), data.WI_Joint_Type);
          setWiWelderId(linkedData);
          if (data.WI_Wpq_Radio !== WPQ_Linking_Radio.UnLinked) {
            showPopUp("WPQLinkGrid", "Multiple", "WI_Welder_Id", linkedData);
          }
          setLoading(false);
        }}
        size="sm"
      >
        {data.WI_Welder_Id}
      </Button>
    );
  };

  const tmpcolumnDefs = [
    {
      headerName: "Project No.",
      field: "WI_Project_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Joint Type",
      field: "WI_Joint_Type",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Joint No.",
      field: "WI_Joint_No",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    },
    {
      headerName: "Linked WPQs",
      field: "WI_Welder_Id",
      type: "Text",
      isCheckbox: false,
      cellRenderer: "",
    }
  ];

  const headerName = (field) => {
    let name = getHeader_FieldName(field, tmpcolumnDefs, "getHeader");
    return name;
  };

  const fieldName = (header) => {
    let name = getHeader_FieldName(header, tmpcolumnDefs, "getField");
    return name;
  };

  const fetchLinking = async () => {
    const startYear = parseInt(process.env.REACT_APP_START_YEAR) || 2023;
    const currentYear = new Date().getFullYear();
    
    setLoading(true);
    
    try {
      const result = await getWpqNpcilLink();
      if (result && result.length > 0) {
        // Filter for all years from startYear to currentYear
        const filter = result.filter(item => {
          if (item.WI_Createdon) {
            const yearPart = parseInt(item.WI_Createdon.split("-")[0]);
            return yearPart >= startYear && yearPart <= currentYear;
          }
          return false;
        });
        
        // Sort by year descending (most recent first)
        filter.sort((a, b) => {
          const yearA = parseInt(a.WI_Createdon?.split("-")[0] || 0);
          const yearB = parseInt(b.WI_Createdon?.split("-")[0] || 0);
          return yearB - yearA;
        });
        
        setGroove(filter);
        setFilteredResult(filter);
        fetchColumnDefns();
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchColumnDefns = () => {
    const result = GlobalColumnDefinations(tmpcolumnDefs);
    result[2].cellRenderer = jointHyperLinkRenderer;
    result[3].cellRenderer = hyperLinkRenderer;
    result.push({
      headerName: "",
      cellRenderer: actionRenderer,
      minWidth: 250,
      suppressMenu: true,
      sortable: false,
    });
    setColumnDefs(result);
  };

  useEffect(() => {
    fetchLinking();
  }, [npcilflag]);

  function handleClick() {
    navigate("/WpqNpcilLinking/AddEdit", {
      state: { data: "", action: "Add" },
    });
  }

  function handleClickedit(row) {
    navigate("/WpqNpcilLinking/AddEdit", {
      state: {
        data: { "PK": row.PK, "SK": row.SK },
        action: "Edit",
      }
    });
  }

  useImperativeHandle(ref, () => ({
    handleAdd: () => {
      handleClick();
    },
  }));

  const modalOnClick = () => {
    history.push({
      pathname: "/",
      data: "setGroove",
    });
  };

  const handleCloseSuccess = () => setShowSuccess(false);

  const handleGlobalSearch = (text) => {
    childRef.current.setSearch(text);
  };

  const handleGlobalExport = async () => {
    try {
      let dataToExport = filteredResult;
      if (excelData.length > 0) {
        dataToExport = excelData;
      }

      const filename = "WpqLinking";
      // Define all column headers once, without duplicates
      const allColumnDefs = [
        { headerName: "WI_Project_No", field: "WI_Project_No" },
        { headerName: "WI_Joint_Type", field: "WI_Joint_Type" },
        { headerName: "WI_Joint_No", field: "WI_Joint_No" },
        { headerName: "WPQ_RecordNo", field: "WPQ_RecordNo" },
        { headerName: "WPQ_Inspection", field: "WPQ_Inspection" },
        { headerName: "WPQ_PlantLocation", field: "WPQ_PlantLocation" },
        { headerName: "WPQ_Qualificationcode", field: "WPQ_Qualificationcode" },
        { headerName: "WPQ_specialNote", field: "WPQ_specialNote" },
        { headerName: "WPQ_WelderName", field: "WPQ_WelderName" },
        { headerName: "WPQ_WelderId", field: "WPQ_WelderId" },
      ];

      // Process each item to enrich with linked WPQ data
      const processedResult = await Promise.all(
        dataToExport.map(async (item) => {
          try {
            let eachNpcilWPQSKs = await getWPQLinkingData(item);
            const linkedData = await getLinkedWPQRecords(eachNpcilWPQSKs.join(","), item.WI_Joint_Type);
            return {
              ...item,
              WPQ_WelderId: linkedData.map(wpq => wpq.WPQ_WelderId).join(', '),
              WPQ_WelderName: linkedData.map(wpq => wpq.WPQ_WelderName).join(', '),
              WPQ_RecordNo: linkedData.map(wpq => wpq.WPQ_RecordNo).join(', '),
              WPQ_Inspection: linkedData.map(wpq => wpq.WPQ_Inspection).join(', '),
              WPQ_PlantLocation: linkedData.map(wpq => wpq.WPQ_PlantLocation).join(', '),
              WPQ_Qualificationcode: linkedData.map(wpq => wpq.WPQ_Qualificationcode).join(', '),
              WPQ_specialNote: linkedData.map(wpq => wpq.WPQ_specialNote).join(', '),
            };
          } catch (error) {
            console.error("Error processing item:", item, error);
            return item; // fallback to original item if error occurs
          }
        })
      );
      // Export the processed data
      if (processedResult && processedResult.length > 0) {
        setExcelData(processedResult);
        handleExport1(processedResult, filename, allColumnDefs);
      } else {
        setExcelData([]);
      }
    } catch (error) {
      console.error("Error in handleGlobalExport:", error);
    }
  };


  const actionRenderer = (params) => {
    return (
      <UnifiedActionRenderer
        actions={['edit']}
        selectedData={params}
        handleEditEvent={(params) => handleClickedit(params.data)}
      />
    );
  };



  return (
    <>
      {loading && (
        <div className="loader-overlay">
          <GridLoader size={10} className="pageloader" />
        </div>
      )}
      <Container fluid>
        <SuccessAlertModal
          clickFunction={modalOnClick}
          msg={msg}
          show={showSuccess}
          handleClose={handleCloseSuccess}
        />
        <Row className="RowHeight">
          <Col md={2} sm={12} xs={12} className="ListTitle">
            WPQ Transaction list
          </Col>
          <Col>
            <div className="global-search-container">
              <GolbalSearch
                searchplaceholdertext={
                  "Search for " +
                  " Project No, Joint Type, Joint No, Linked WPQ"
                }
                withYear={false}
                filterFunc={handleGlobalSearch}
              />
              <img
                className="allexport"
                src={Export}
                alt="Export"
                onClick={handleGlobalExport}
              />
            </div>
          </Col>
        </Row>
        <GridMaster
          rowDetails={filteredResult}
          colDetails={columnDefs}
          fieldNames={fieldName}
          headerNames={headerName}
          setExcelData={(data) => setExcelData(data)}
          ref={childRef}
        />
        <RenderIf isTrue={popUp.type === "Multiple" && showForm}>
          <MultiValuePopUp
            show={showForm}
            onHide={() => setShowForm(false)}
            masterName={popUp.name}
            paramkey={popUp.key}
            paramvalue={popUp.value}
            backdrop="static"
            JointType={jointType}
            WIWelderid={wiWelderId}
            wiobj={welData}
          />
        </RenderIf>
        <Toaster />
      </Container>
    </>
  );
});

export default WpqNpcilLinking;